'use client'

import { Toaster } from '@/components/ui/toaster'

export function ToasterProvider() {
  return <Toaster />
}
